import React, { FC } from 'react';
import { Text } from 'react-native';
import i18n from 'i18n-js';

import ColorWrapper, { WithColor } from '@styles/colors';
import { font } from '@styles/fonts';
import { secondsToHours } from '@helpers';
import { BULLET } from '@v2/pages/common/constants/base.constants';

export interface DashboardOverviewTopBlockSummaryItemProps extends WithColor {
  color: string;
  seconds: number;
  count: number;
  label: string;
}

const DashboardOverviewTopBlockSummaryItem: FC<DashboardOverviewTopBlockSummaryItemProps> = ({ C, color, seconds, count, label }) => {
  return (
    <Text style={[font['Subhead 1 bold'], { color: C(color) }]}>
      {secondsToHours(seconds)} <Text style={[font.Body, { color: C('Label/Light/Primary') }]}>{BULLET}</Text>{' '}
      <Text style={[font['Subhead 1'], { color: C('Label/Light/Tertiary') }]}>
        {count} {i18n.t(label)}
      </Text>
    </Text>
  );
};

export default ColorWrapper(DashboardOverviewTopBlockSummaryItem);
